import { ReactElement, useState } from "react";

interface IGanttSlider {
  width: number;
  top: number;
  percent: number;
  onOffsetChange: (offset: number) => void;
}

const backRectHeight = 10;
const frontRectHeight = 20;
const backRectTop = 15;
const frontRectTop = 10;

const GanttSlider = ({ width, top, percent, onOffsetChange }: IGanttSlider): ReactElement => {
  const [ offset, setOffset ] = useState(0);

  const maxOffset = 1 - percent;
  const windowWidth = percent * width;
  const btnA =  40 / width;

  const f1 = percent / 2.0;
  const factor = Math.min(f1, maxOffset);

  const onMouseDown = (forward: boolean) => {
    if (forward) {
      const flag =  offset + factor < maxOffset;

      setOffset(flag ? offset + factor : maxOffset);
      onOffsetChange(flag ? offset + factor : maxOffset);
    } else {
      setOffset(offset - factor > btnA ? offset - factor : 0);
      onOffsetChange(offset - factor > btnA ? offset - factor : 0);
    }
  };

  return(
    <g transform={`translate(${0}, ${top})`}>


      <rect
        fill="#AFAFAF"
        x={0}
        y={backRectTop}
        width={width}
        height={backRectHeight} />

      <rect
        fill="transparent"
        stroke="#5F88DC"
        strokeWidth={4}
        x={offset * width}
        y={frontRectTop}
        rx={2}
        ry={2}
        width={windowWidth}
        height={frontRectHeight}
      />


      {offset > 0 &&
        <g transform={"translate(0, 0)"}
          onMouseUp={() => onMouseDown(false)}
          onTouchEnd={() => onMouseDown(false)}>
          <rect
            stroke="#AFAFAF"
            fill="#FFF"
            x={0}
            y={0}
            width={40}
            height={40}
            rx={20}
            ry={20}
            cursor="pointer"
          />
          <g transform="translate(-2, 0)">
            <path
              d="M25.5,5.5 C25.5,5.5 30.5,10.5 30.5,10.5 C30.5,10.5 20.5,20.5 20.5,20.5 C20.5,20.5 30.5,30.5 30.5,30.5 C30.5,30.5 25.5,35.5 25.5,35.5 C25.5,35.5 10.5,20.5 10.5,20.5 C10.5,20.5 25.5,5.5 25.5,5.5"
              fill="#AFAFAF"/>
          </g>
        </g>
      }

      {maxOffset - offset > 0.01 &&
        <g transform={`translate(${width - 40}, 0)`}
          onMouseUp={() => onMouseDown(true)}
          onTouchEnd={() => onMouseDown(true)}>
          <rect
            stroke="#AFAFAF"
            fill="#FFF"
            x={0}
            y={0}
            width={40}
            height={40}
            rx={20}
            ry={20}
            cursor="pointer"
          />
          <g transform={"translate(1, 0)"}>
            <path
              d="M15.5,5.5 C15.5,5.5 10.5,10.5 10.5,10.5 C10.5,10.5 20.5,20.5 20.5,20.5 C20.5,20.5 10.5,30.5 10.5,30.5 C10.5,30.5 15.5,35.5 15.5,35.5 C15.5,35.5 30.5,20.5 30.5,20.5 C30.5,20.5 15.5,5.5 15.5,5.5"
              fill="#AFAFAF"/>
          </g>
        </g>
      }
    </g>
  );
};

export default GanttSlider;
